import React from 'react';
import { useLanguage } from '../lib/LanguageContext';
export function FAQSection() {
  const {
    t
  } = useLanguage();
  return <div className="my-12 space-y-8" data-id="element-2">
      <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl text-white font-bold mb-8 text-center" data-id="element-3">
        {t.faq.heading}
      </h2>
      <div className="space-y-8" data-id="element-4">
        {t.faq.items.map((faq, index) => <div key={index} className="bg-[#111111] p-6 border-l-2 border-[#c9a84c]" data-id="element-5">
            <h4 className="font-bold text-white text-xl mb-3" data-id="element-6">{faq.q}</h4>
            <p className="text-[#f5f0e8] text-lg leading-relaxed" data-id="element-7">{faq.a}</p>
          </div>)}
      </div>
    </div>;
}